import React, {useContext, useState} from 'react';
import '../styles/AuthPage.css'
import '../styles/vars.css'
import { setCookie } from "../utils/cookies";
import { loginApi } from "../http/userApi";
import {Context} from "../index";
import PasswordToggleButton from "../components/PasswordToggleButton";
const jwt_decode = require("jwt-decode");


const Auth = () => {
    const { user } = useContext(Context)
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    async function onBtnClick(e: any) {
        e.preventDefault();
        const { username, password, memorizeMe } = e.target;

        if (memorizeMe.checked === true) {
            setCookie('username', username.value, 365);
            setCookie('password', password.value, 365);
        } else {
            setCookie('username', '', -365);
            setCookie('password', '', -365);
        }

        const res = await loginApi({
            username: username.value, password: password.value });
        
        if (res.response){
            if (res.response.status >= 400) {
                addMessage(res.response.data.message, 'red');
            }
        } else if (res.data) {
            if (res.status === 200) {
                addMessage(res.data.message, 'green');
                user.setIsAuth(true)
                user.setUser(jwt_decode.jwtDecode(res.data.token));
            }
        }

    }


    return (
        <div className="auth">
            <div className='auth__auth-form-container'>
                <div className='auth__body'>
                    <form className='auth__form' onSubmit={onBtnClick}>
                        <span id='authMsg'></span>
                        <div className='field'>
                            <label className='field__label' htmlFor='username'>Логін</label>
                            <input id='username' name='username'
                                   required={true} className='input auth__form-login auth__form-input' type="text"
                                   autoComplete="username"
                                   maxLength={24}/>
                        </div>
                        <div className='field'>
                            <label className='field__label' htmlFor='password'>Пароль</label>
                            <div className='password-field'>
                                <input id='password' name='password'
                                       required={true} className='input auth__form-password auth__form-input'
                                       type={isPasswordVisible ? 'text' : 'password'}
                                       autoComplete="current-password" maxLength={24}/>
                                <PasswordToggleButton isVisible={isPasswordVisible}
                                                       onToggle={() => setIsPasswordVisible(!isPasswordVisible)}/>
                            </div>
                        </div>
                        <div className='auth__mmrzMe-container'>
                            <label className='auth__mmrzMe-label'>
                                <input id='memorizeMe' name='memorizeMe' type='checkbox'/>
                                <span>Запомнить меня</span>
                            </label>
                        </div>
                        <button className='nav__button btn-primary auth__form-button' type='submit'>Войти</button>
                    </form>
                </div>
            </div>
        </div>
    );
};


export default Auth;


function addMessage(message: string, color: string) {
    let msg: HTMLElement | null = document.getElementById('authMsg');
    if (msg) {
        msg.innerHTML = message;

        switch (color) {
            case 'red':
                msg.style.color = 'var(--warning-color)'
                break
            case 'green':
                msg.style.color = 'var(--success-color)'
                break
        }
    }
}
